export const unreachableFallback = (_value, fallback) => fallback;